import { catalogPlugin } from '@backstage/plugin-catalog';
import { orgPlugin } from '@backstage/plugin-org';
import { navModule } from './modules/nav';
import { keycloakAuthApi, scmAuthApi, scmIntegrationsApi, signInPage, userSettingsAuthModule } from './modules/auth/index';

import { AutoLogout } from '@backstage/core-components';
import authPlugin from '@backstage/plugin-auth';
import {createApp} from '@backstage/frontend-defaults';
import { SignalsDisplay } from '@backstage/plugin-signals';

import { exxLightTheme, exxDarkTheme } from './modules/theme';

import dashboardPlugin from 'backstage-plugin-dashboard';

import {
    AppRootElementBlueprint,
    createFrontendModule,
} from '@backstage/frontend-plugin-api';
import { techRadarApi, techRadarPage } from './pages/techradar';

const signalsDisplayElement = AppRootElementBlueprint.make({
    name: 'signals',
    params: {
        element: <SignalsDisplay />,
    },
});

const autoLogoutElement = AppRootElementBlueprint.make({
    name: 'auto-logout',
    params: {
        element: (
            <AutoLogout
                idleTimeoutMinutes={30}
                useWorkerTimers
                logoutIfDisconnected
            />
        ),
    },
});

const app = createApp({
    features: [
        authPlugin,
        dashboardPlugin,
        createFrontendModule({
            pluginId: 'app',
            featureFlags: [
                { name: 'ai-agent-data-maintenance' },
                { name: 'dashboard-enable' },
            ],
            extensions: [
                keycloakAuthApi,
                scmIntegrationsApi,
                scmAuthApi,
                techRadarApi,
                signInPage,
                exxLightTheme,
                exxDarkTheme,
                signalsDisplayElement,
                autoLogoutElement,
                techRadarPage,
            ],
        }),
        navModule,
        userSettingsAuthModule,
    ],
    bindRoutes({bind}) {
        bind(orgPlugin.externalRoutes, {
            catalogIndex: catalogPlugin.routes.catalogIndex,
        });
    },
});

export default app.createRoot();
